import React, { useMemo } from 'react';
import DayJs from 'utils/Dayjs';
import Icon from 'components/Misc/Icon';

const Dates = ({ startDate, endDate }) => {
	const range = useMemo(() => ({
		start: DayJs(startDate).format('D. MMM, YYYY'),
		end: DayJs(endDate).format('D. MMM, YYYY')
	}), [startDate, endDate]);

	return (
		<div className="flex items-center justify-around space-x-2 bg-neutral-50 dark:bg-neutral-700 text-neutral-700 dark:text-white rounded-full py-1 px-3 transition-colors">
			<div className="text-sm flex-1 text-center whitespace-nowrap">
				{range.start}
			</div>

			<Icon
				icon="arrow_forward"
				className="text-xs"
			/>

			<div className="text-sm flex-1 text-center whitespace-nowrap">
				{range.end}
			</div>
		</div>
	);
};

export default Dates;